import React from "react";
import { TextAreaEdit } from "../../../../components/TextAreaEdit";
import { HomeFAQ } from "./HomeFAQ";

interface FAQContentProps {
  data: HomeFAQ;
  update: (fieldsToUpdate: Partial<HomeFAQ>) => void;
}

export const HomeFAQContent: React.FC<FAQContentProps> = ({ data, update }) => {
  return (
    <div className="specializations-faq__content">
      <TextAreaEdit
        name="heading"
        value={data.heading}
        setValue={update}
        className="content-heading"
      />

      <TextAreaEdit
        name="description"
        value={data.description}
        setValue={update}
        className="content-description"
      />
    </div>
  );
};
